import { addDays } from "./date";
import type { KayaState } from "./types";

/**
 * Whether this phone has the Kaya Steps app: an Android phone whose account received a count from
 * the app's own sensor reader in the last week. There is no way to ask the app directly — an
 * `intent:` either opens it or does nothing — so the evidence is what it posted.
 *
 * Two screens act on the answer: Refresh steps pings the app only when it is there (a ping to
 * nothing reloads the page on some browsers), and a walk's spoken cues come from the app when it is
 * there and from the page otherwise, so a pocketed phone with its screen off still speaks (ADR-063,
 * ADR-064). `android` is the caller's `lib/device.ts::isAndroid()` — the domain cannot read the
 * browser, and the same account signed in on a laptop must not count.
 */
export function hasCounterApp(S: KayaState, today: string, android: boolean): boolean {
  if (!android) return false;
  const since = addDays(today, -7);
  return Object.entries(S.logs).some(([ds, L]) => ds >= since && ds <= today && L.deviceStepsSource === "android-sensor");
}
